import { TRADE_TERM_APPLY_TO } from "@/static/tradeTermApplyToTypes";
import { TRADE_TERM_TYPE_ENUM } from "@/static/tradeTermTypeEnum";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString } from "class-validator";

export class ContractorTradeTermAddEdit {
  @Expose()
  @IsString()
  @IsOptional()
  name!: string;

  @Expose()
  @IsEnum(TRADE_TERM_APPLY_TO)
  appliesTo!: TRADE_TERM_APPLY_TO;

  @Expose()
  @IsEnum(TRADE_TERM_APPLY_TO)
  calculatedFrom!: TRADE_TERM_APPLY_TO;

  @Expose()
  @IsNumber()
  value!: number;

  @Expose()
  @IsBoolean()
  isPercentage!: boolean;

  @Expose()
  @IsBoolean()
  isHidden!: boolean;

  @Expose()
  @IsEnum(TRADE_TERM_TYPE_ENUM)
  type!: TRADE_TERM_TYPE_ENUM;

  @Expose()
  @IsNumber()
  @IsOptional()
  commissionServiceId!: null | number;

  @Expose()
  @IsString()
  @IsOptional()
  commissionServiceName!: string;

  @Expose()
  @IsString()
  currency!: string;

  @Expose()
  @IsBoolean()
  separateItem!: boolean;

  @Expose()
  @IsBoolean()
  separateItemOnOrder!: boolean;

  @Expose()
  @IsBoolean()
  stayOnOrder!: boolean;

  @Expose()
  @IsNumber()
  @IsOptional()
  attributePrototypeId!: null | number;

  @Expose()
  @IsString()
  @IsOptional()
  attributePrototypeName!: string;

  @Expose()
  @IsNumber()
  @IsOptional()
  appliesToAttributePrototypeId!: null | number;

  @Expose()
  @IsString()
  @IsOptional()
  appliesToAttributeValue!: string;

  constructor() {
    this.name = "";
    this.appliesTo = TRADE_TERM_APPLY_TO.All;
    this.calculatedFrom = TRADE_TERM_APPLY_TO.All;
    this.value = 0;
    this.isPercentage = false;
    this.isHidden = false;
    this.type = TRADE_TERM_TYPE_ENUM.Together;
    this.commissionServiceId = null;
    this.currency = "PLN";
    this.separateItem = false;
    this.stayOnOrder = false;
    this.attributePrototypeId = null;
    this.appliesToAttributePrototypeId = null;
  }
}
